// returns the region from a locale lang key
// 'en-us' -> 'us'
export function getRegionFromLocale(locale: string) {
  return locale.split('-')[1];
}
